import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Button } from '../Button';
export interface ExportButtonProps {
  /**
   * The label of the button
   */
  label: string;
  /**
   * Whether the device is small
   */
  isSmallDevice: boolean;
  /**
   * The render function for the Export modal
   */
  render: ({ handleClose }: { handleClose: () => void }) => JSX.Element;
  /**
   * Optional data test id for the button
   */
  dataTestId?: string;
  disabled: boolean;
  /**
   * Optional margin right for the button
   */
  mr?: number;
}
const exportIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M6.66663 14.1667L9.99996 17.5M9.99996 17.5L13.3333 14.1667M9.99996 17.5V10M16.6666 13.9524C17.6845 13.1117 18.3333 11.8399 18.3333 10.4167C18.3333 7.88536 16.2813 5.83333 13.75 5.83333C13.5679 5.83333 13.3975 5.73833 13.3051 5.58145C12.2183 3.73736 10.212 2.5 7.91663 2.5C4.46485 2.5 1.66663 5.29822 1.66663 8.75C1.66663 10.4718 2.36283 12.0309 3.48908 13.1613"
      stroke="inherit"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ExportButton = ({
  label,
  isSmallDevice,
  render,
  dataTestId = undefined,
  disabled,
  mr,
}: ExportButtonProps): JSX.Element => {
  const theme = useTheme();
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElement(null);
  };
  return (
    <>
      <Button
        variant="outlined"
        startIcon={!isSmallDevice && exportIcon}
        aria-label={label}
        onClick={handleClick}
        sx={{ stroke: theme.palette.primary.main, mr }}
        data-testid={dataTestId}
        disabled={disabled}
      >
        {isSmallDevice ? exportIcon : label}
      </Button>

      {!!anchorElement && render({ handleClose })}
    </>
  );
};
